<template>
  <div class="alert alert-danger position-fixed shadow alert-dismissible"
       role="alert"
       style="right: 0;top:50px;z-index:10000;"
       v-if="error">
    <h4 class="alert-heading">Ошибка!</h4>

    <p>{{error}}</p>

    <button type="button" class="close" @click="closeError">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
  export default {
    name: "Error",

    computed: {
      error() {
        return this.$store.state.error;
      }
    },

    methods: {
      closeError() {
        this.$store.commit('SET_ERROR', '');
      },
    },
  };
</script>
